import { z } from 'zod';
import { groupTypeSchema } from '../enums/group';

export const AccountSchema = z.object({
  id: z.coerce.number(),
  identifier: z.uuid(),
  name: z.string(),
  contractTerm: z.coerce.date().nullable(),
  address: z.string().nullable(),
  endDate: z.coerce.date().nullable(),
  url: z.string().nullable(),
  trinityCode: z.string().nullable(),
  createdOn: z.coerce.date(),
  typeId: groupTypeSchema,
  defaultBrand: z.object({
    id: z.coerce.number(),
    name: z.string(),
  }).nullable(),
  domains: z.array(z.string()),
});
export const AccountTableItemSchema = AccountSchema.extend({
  usersCount: z.coerce.number(),
}).omit({ defaultBrand: true });
export type AccountModel = z.infer<typeof AccountSchema>;
export type AccountTableItem = z.infer<typeof AccountTableItemSchema>;

export const AccountAuditSchema = z.object({
  id: z.coerce.number(),
  name: z.string().nullable(),
});
export type AccountAudit = z.infer<typeof AccountAuditSchema>;